// GUARDED COPY of the Web's src/utils/priceLine.js (2026-10-31): dollars large,
// credits beneath, for the print shop. Edit the Web original, then
// `node scripts/check_face_decal_sync.mjs --sync`.
/* ── VERBATIM FROM HypeTunes_Web_2026 BELOW THIS LINE ── */
/**
 * priceLine — the ONE way a price is printed: dollars large, credits beneath.
 *
 * Khari, 2026-09-21: *"We may be able to keep the credit system in place on the
 * backend so we can keep units in place for our own tracking and pricing, but on
 * the front end, that would be translated to dollar figures."*
 *
 * ⚠ THE DOLLARS ARE A LABEL AND THE CREDITS ARE THE CHARGE. The server sends
 * both; `display.label` is already resolved from `ShowPricingService
 * .usdPerCredit()` — the single rate, 2026-09-23: *"USD_PER_CREDIT should be
 * the resolution."* So this renders the label and does NO arithmetic.
 * Converting credits to dollars here would put a second exchange rate in the
 * product, and the two would disagree the first time a pack is repriced.
 *
 * ⚠ THE CREDITS STAY VISIBLE, UNDERNEATH. The balance this spends is
 * denominated in credits; showing only dollars would leave the buyer unable to
 * tell whether they can afford it.
 *
 * With no label (the server could not resolve a rate) the credits become the
 * price rather than nothing — a figure the charge will actually match.
 *
 * Moved out of `ShowsTab` on 2026-09-23 when the song form needed the same
 * shape ([[feedback_extract_dont_copy]]).
 *
 * @param {{ credits: number, display?: { label?: string } } | null} price
 * @returns {{ amount: string, note: string | null } | null}
 */
export function priceLine(price) {
  if (!price || !Number.isFinite(Number(price.credits))) return null;
  const credits = Number(price.credits);
  const unit = `${credits} credit${credits === 1 ? '' : 's'}`;
  const label = price.display?.label;
  return label ? { amount: label, note: unit } : { amount: unit, note: null };
}
